// @flow
// ----------------------------------------------------------------------
// <copyright file='Izenda.ReportViewerHeader.jsx' company='Izenda'>
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import DropDown from 'share/components/controls/Izenda.DropDown';
import ReportName from 'modules/Reports/ReportList/Izenda.ReportName';
import reportDesignerConstants from 'logic/data/Izenda.ReportDesignerConstants';
import classnames from 'classnames';
import GridLayout from 'share/components/controls/Izenda.GridLayout';
import connect from 'share/enhancers/Izenda.Connect';
import { isNil, get } from 'lodash/fp';
import actions from './Izenda.ReportViewerActions';
const SUBSCRIPTION_MODE_COL_NUMBER = 12;
const NON_SUBSCRIPTION_MODE_COL_NUMBER = 8;

@connect(actions)
export default class ReportViewerHeader extends Component {
  static propTypes = {
    store: PropTypes.object,
    boardDetail: PropTypes.object,
    fieldStore: PropTypes.object
  };

  /**
   * Change preview record
   * @param {Event} e
   */
  changePreviewRecord = (e: Event) => {
    const {
      fieldStore,
      fieldStore: {
        reportStore: { model }
      }
    } = this.props;
    model.updatePreviewRecord(e.value);
    fieldStore.reportFilters.resetUpdateResult();
    this.props.updateReportParts();
  };

  /**
   * Change report name
   * @param {string} name
   */
  changeName = (name: string) => {
    const {
      fieldStore: {
        reportStore: { model }
      }
    } = this.props;

    model.changeName(name);
  };

  render() {
    const {
      localization,
      fieldStore: {
        reportStore: {
          model,
          model: {
            displayMode: { isSubscriptionMode }
          }
        }
      },
      boardDetail
    } = this.props;

    const previewRecordsContainerClassName = classnames({
      u_none: isSubscriptionMode,
      u_block: !isSubscriptionMode
    });

    const reportNameCols = isSubscriptionMode ? SUBSCRIPTION_MODE_COL_NUMBER : NON_SUBSCRIPTION_MODE_COL_NUMBER;
    const hideReportName = get('integrationStyle.hideReportName', this.props);
    const hidePreviewRecords = get('integrationStyle.hidePreviewRecords', this.props);

    return (
      <GridLayout>
        <GridLayout.Row className='izenda-ReportHeader'>
          <GridLayout.Col cols={reportNameCols} className='report-name'>
            {!isNil(boardDetail) && !hideReportName && (
              <ReportName {...this.props} dataDetail={boardDetail} updateName={this.changeName} />
            )}
          </GridLayout.Col>
          <GridLayout.Col cols='4' className={previewRecordsContainerClassName}>
            {!hidePreviewRecords && (
              <div className='u_table u_fullWidth u_paddingInner u-bgWhite preview-records'>
                <span className='u_tableCell control-label'>
                  {localization.getText('REPORTDESIGNER_LABEL_PREVIEW_RECORDS')}
                </span>
                <div className='u_tableCell u_fullWidth'>
                  <DropDown
                    options={reportDesignerConstants.PREVIEW_RECORD}
                    value={model.previewRecord}
                    labelField='label'
                    valueField='value'
                    onChange={this.changePreviewRecord}
                  />
                </div>
              </div>
            )}
          </GridLayout.Col>
        </GridLayout.Row>
      </GridLayout>
    );
  }
}



// WEBPACK FOOTER //
// ./ui/modules/Reports/ReportViewer/Izenda.ReportViewerHeader.js